import React from "react";

export default ({org}) => {
    if(!org?.large_logo_url) return <></>

    return (
        <img src={org.large_logo_url} style={{margin: '0 auto 1em auto', display: 'block', objectFit: 'contain', width: '100%'}}/>
    )
}
